import React from "react";

const Loader = () => {
	return (
		<div id="pageloader">
			<div className="loader-item">
				<div className="loader">
					<div className="spin"></div>
					<div className="bounce"></div>
				</div>
			</div>
		</div>
	);
};

export default Loader;
